import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BatchComponent } from './batch.component';

const routes: Routes = [
  {
    path: '',
    component: BatchComponent,
    children: [
      {
        path: '',
        redirectTo: 'batches',
        pathMatch: 'full',
      },
      {
        path: 'batches',
        loadChildren: () =>
          import('./features/batches/batches.module').then(
            (m) => m.BatchesModule
          ),
      },
      {
        path: 'blanks',
        loadChildren: () =>
          import('./features/blanks/blanks.module').then((m) => m.BlanksModule),
      },
      {
        path: 'invoices',
        loadChildren: () =>
          import('./features/invoices/invoices.module').then(
            (m) => m.InvoicesModule
          ),
      },
      {
        path: 'addresses',
        loadChildren: () =>
          import('./features/addresses/addresses.module').then(
            (m) => m.AddressesModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BatchRoutingModule {}
